import styled from "styled-components";

import { Summary } from "../../../styles/typography/Summary.styled";

const StyledErrorBanner = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-left: ${({ theme }) =>
    theme.hasStripeOnErrorBanner
      ? `4px solid ${theme.colors.highlight3}`
      : "none"};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusBanner};
  background-color: ${({ theme }) => theme.colors.baseWhite};
  white-space: pre-wrap;

  img {
    margin-right: 8px;
  }

  ${Summary} {
    margin-bottom: 8px;
  }
`;

export default StyledErrorBanner;
